import { Country, Layout, ModalPosition } from '@app/enums';

export const RegexHexColor = /^#[A-Fa-f0-9]{6}$/;

export const countryValues = Object.values(Country);
export const modalPositionValues = Object.values(ModalPosition);
export const layoutValues = Object.values(Layout);
